function SvgRightUp() {
  return (
    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.526507 6L5.25411 1.27706L5.25411 4.83303L6 4.83303L6 0L1.18464 -2.10486e-07L1.18464 0.748624L4.7276 0.748624L-1.15253e-07 5.47156L0.526507 6Z" fill="#414042"/>
</svg>

  )
}

export default SvgRightUp;